import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AppDB } from 'src/app/config/idb';
import { EInspectionStepUrl } from 'src/app/interfaces/PWA/Inspection';
import { OrientationService } from 'src/app/services/General/Orientation/orientation.service';
import { InspectionControlService } from 'src/app/services/InspectionHandlers/InspectionControl/inspection-control.service';
import { ProgressService } from 'src/app/services/InspectionHandlers/Progress/progress.service';
import { StepManagerService } from 'src/app/services/InspectionHandlers/StepManager/step-manager.service';
import { TourManagerService } from 'src/app/services/InspectionHandlers/TourManager/tour-manager.service';
import { RouteSharedDataService } from 'src/app/services/Workarounds/RouteSharedData/route-shared-data.service';
import { ErrorService } from 'src/app/services/General/Error/error.service'; // added
import { PhotoAnalysisService } from 'src/app/services/InspectionHandlers/photoAnalysis.service';
import { PhotoStorageService } from 'src/app/services/General/PhotoStorage/photo-storage.service';
import { PHOTO_STATE_TIMEOUT_ON_RESUME_MS } from 'src/app/utils/StateReconciliation';

@Injectable({
  providedIn: 'root',
})
export class InspectionInitResolverService {
  // newData = false;

  constructor(
    private readonly inspectionControlService: InspectionControlService,
    private readonly stepManagerService: StepManagerService,
    private readonly progressService: ProgressService,
    private readonly errorService: ErrorService,
    private readonly photoAnalysisService: PhotoAnalysisService,
    private readonly photoStorageService: PhotoStorageService
  ) {
  }

  async resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<any> {
    try {
      // El timer va primero porque es el que decide si la inspección sigue vigente: con el JWT
      // vencido caduca y limpia el estado local, y ahí descartar es lo correcto. Recién después
      // tiene sentido drenar la cola, que es el caso de la inspección viva.
      await this.setTimer();
      // Se espera a propósito: el criterio es de ORDEN —subir lo pendiente antes de cualquier
      // limpieza de estado— y dispararlo sin esperar lo dejaría corriendo contra la navegación,
      // que es lo que habilita dos drenajes simultáneos. No puede voltear el resolver:
      // `resumePendingWork` no lanza.
      await this.photoStorageService.resumePendingWork(PHOTO_STATE_TIMEOUT_ON_RESUME_MS);
      const steps = this.stepManagerService.getSteps();
      this.progressService.setCurrentProgress(steps);
      const jwt = localStorage.getItem('jwt');
      // Cerrada, no hay veredictos que esperar, y una conexión nueva terminaría pidiendo `push/auth` con el JWT vencido.
      if (jwt && !this.inspectionControlService.isInspectionFinished()) {
        this.photoAnalysisService.subscribeToPhotoAnalysis(jwt);
      }
    } catch (error) {
      this.errorService.showErrorScreen(); // changed
    }
  }

  async setTimer(): Promise<void> {
    await this.inspectionControlService.initInspectionTimer();
  }
}
